/**
 * Règles de validation de mot de passe "strong"
 */

export const PASSWORD_RULES = [
  { id: 'length', label: '12 caractères minimum', test: (pw) => pw.length >= 12 },
  { id: 'uppercase', label: '1 majuscule', test: (pw) => /[A-Z]/.test(pw) },
  { id: 'lowercase', label: '1 minuscule', test: (pw) => /[a-z]/.test(pw) },
  { id: 'digit', label: '1 chiffre', test: (pw) => /\d/.test(pw) },
  { id: 'special', label: '1 caractère spécial (!@#$...)', test: (pw) => /[^A-Za-z0-9]/.test(pw) },
]

/**
 * Valide un mot de passe et retourne { valid, errors, strength }
 * strength: 0-5 (nombre de règles satisfaites)
 */
export function validatePassword(password) {
  const results = PASSWORD_RULES.map((rule) => ({
    ...rule,
    passed: rule.test(password),
  }))

  const strength = results.filter((r) => r.passed).length
  const errors = results.filter((r) => !r.passed).map((r) => r.label)

  return {
    valid: strength === PASSWORD_RULES.length,
    errors,
    strength,
    results,
  }
}
